import { AxiosRequestConfig } from 'axios';
import axiosIntercept from '../app/authentication/axiosIntercept';
import { ITransferUniversalDashBoardData } from '../types/CommonTypes';
import { DASHBOARD_API_CONSTANT } from '../utils/PathConstants';

export const sendToUniversalDashboard = async (
	payload: ITransferUniversalDashBoardData,
	config: AxiosRequestConfig = {}
) => {
	const URL = DASHBOARD_API_CONSTANT.DASHBOARD;
	return axiosIntercept.post(URL, payload, {
		...config,
		skipGlobalErrorHandling: true,
	} as AxiosRequestConfig);
};
